import _ from "./index407.js";
import { resolveComponent as a, createElementBlock as o, openBlock as t, createElementVNode as c, createVNode as f, Fragment as u, renderList as h, createBlock as l, createCommentVNode as d, createTextVNode as i, toDisplayString as m } from "vue";
import w from "./index231.js";
const v = ["data-component"], k = {
  ref: "content",
  class: "flex h-56 text-text-l"
}, b = ["href"], g = {
  "data-test-id": "entry",
  class: "flex items-center pointer-events-none whitespace-nowrap"
};
function y(e, j, $, B, N, V) {
  const r = a("ms-arrow"), p = a("ms-json-ld");
  return t(), o("div", {
    ref: "viewport",
    class: "relative overflow-hidden dragscroll",
    "data-component": e.$options.name
  }, [
    c("div", k, [
      (t(!0), o(u, null, h(e.getLinks(), (n, s) => (t(), o("a", {
        key: s,
        "data-test-id": "entry",
        class: "flex items-center pr-16 transition-colors duration-200 whitespace-nowrap hover:underline ease-ms",
        href: n.link
      }, [
        s > 0 ? (t(), l(r, {
          key: 0,
          class: "w-24 mr-16"
        })) : d("", !0),
        i(" " + m(n.title), 1)
      ], 8, b))), 128)),
      c("div", g, [
        e.breadcrumb.length > 1 ? (t(), l(r, {
          key: 0,
          class: "w-24 mr-16"
        })) : d("", !0),
        i(" " + m(e.breadcrumb[e.breadcrumb.length - 1].title), 1)
      ])
    ], 512),
    f(p, {
      "json-ld": e.jsonLd()
    }, null, 8, ["json-ld"])
  ], 8, v);
}
const E = /* @__PURE__ */ w(_, [["render", y]]);
export {
  E as default
};
